/**
 * www marketing hamburger: overlay the panel so the header bar height
 * stays constant at Scout 390. Do not animate height, opacity, or
 * translate - those recomposite the page background on iOS.
 */

export const WWW_MOBILE_NAV_BAR_ATTR = 'data-landing-nav-bar';

/** Shared public chrome overlay id (PR 302 `MarketingNav`). */
export const MARKETING_MOBILE_NAV_ID = 'marketing-mobile-nav';

export const LANDING_MOBILE_NAV_ID = MARKETING_MOBILE_NAV_ID;

export const PRICING_MOBILE_NAV_ID = 'pricing-mobile-nav';

/** Same token as `LANDING_NAV_SAFE_AREA_CLASS` on Landing. */
export const WWW_MOBILE_NAV_SAFE_AREA_CLASS =
  'pt-[env(safe-area-inset-top,0px)]';

export const WWW_MOBILE_NAV_OVERLAY_CLASS =
  'sm:hidden absolute left-0 right-0 top-full overflow-hidden bg-[var(--surface-card)] border-t border-[var(--border-subtle)]';

export const WWW_MOBILE_NAV_LINKS_CLASS = 'px-4 py-4 space-y-3';

/** Closed panel stays mounted and invisible. No opacity tween. */
export const WWW_MOBILE_NAV_CLOSED_CLASS = 'invisible pointer-events-none';

export function wwwMobileNavAnimateState(open) {
  return open ? 'open' : 'closed';
}

export function wwwMobileNavPanelClass(open) {
  if (open) return WWW_MOBILE_NAV_OVERLAY_CLASS;
  return `${WWW_MOBILE_NAV_OVERLAY_CLASS} ${WWW_MOBILE_NAV_CLOSED_CLASS}`;
}
